import classNames from 'classnames';
import { ThemeWBProps } from 'eco-design-micro/props/const';
import { TitleDescWithColorProps } from 'eco-design-micro/props/msg/TitleDescProps';
import EcoImg from 'eco-design/base/eco-img';
import React, { useEffect, useRef } from 'react';
import './index.scss';

export interface EcoWhatInBoxItemProps extends TitleDescWithColorProps {
    /**
     * 图片链接
     */
    pc: string;
}
export interface EcoWhatInBoxProps {
    /**
     * 主题色
     */
    theme?: ThemeWBProps;
    /**
     * 列表
     */
    items?: EcoWhatInBoxItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * what in box
 */
const EcoWhatInBox: React.FC<EcoWhatInBoxProps> = ({ theme = 'white', items = [], className }) => {
    const prefixCls = `eco-what-in-box`;
    const length = items.length;
    const classes = classNames(prefixCls, {
        [`${className}`]: className,
        [`${prefixCls}-theme-${theme}`]: theme,
        [`${prefixCls}-length-${length}`]: length,
    });
    const itemF = items[0] || {};
    const itemStyleCompF = {
        '--eco-what-in-box-titleColor': itemF.titleColor,
        '--eco-what-in-box-descColor': itemF.descColor,
    } as React.CSSProperties;

    const itemSR = items.slice(1);
    const refA = useRef(null);

    // 给每个子项设置最小高度以对齐
    const setItemMinHeight = () => {
        // 头部
        const listDomsB = (refA.current as any).querySelectorAll('.eco-what-in-box-items-r .eco-what-in-box-item-msg');
        let minHeightB = 24;
        for (let i = 0; i < listDomsB.length; i++) {
            const elemA = listDomsB[i];
            const clientHeight = elemA.clientHeight;
            minHeightB = Math.max(minHeightB, clientHeight);
        }

        // 设置最小高度
        for (let i = 0; i < listDomsB.length; i++) {
            const elemA = listDomsB[i];
            elemA.style.minHeight = `${minHeightB}px`;
        }
    };
    useEffect(() => {
        setItemMinHeight();
    }, []);
    return (
        <div className={classes} ref={refA}>
            <div className={`${prefixCls}-items`}>
                <div className={`${prefixCls}-items-l`}>
                    <div className={`${prefixCls}-item ${prefixCls}-item-1`} style={itemStyleCompF}>
                        <div className={`${prefixCls}-item-msg`}>
                            <div className={`${prefixCls}-item-title`}>{itemF.title}</div>
                        </div>
                        <div className={`${prefixCls}-item-img-out`}>
                            <div className={`${prefixCls}-item-img`}>
                                <EcoImg pc={itemF.pc} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`${prefixCls}-items-r`}>
                    {itemSR.map((item: EcoWhatInBoxItemProps, index: number) => {
                        const itemStyleComp = {
                            '--eco-what-in-box-titleColor': item.titleColor,
                            '--eco-what-in-box-descColor': item.descColor,
                        } as React.CSSProperties;
                        return (
                            <div key={index} className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`} style={itemStyleComp}>
                                <div className={`${prefixCls}-item-msg`}>
                                    <div className={`${prefixCls}-item-title`}>{item.title}</div>
                                </div>
                                <div className={`${prefixCls}-item-img-out`}>
                                    <div className={`${prefixCls}-item-img`}>
                                        <EcoImg pc={item.pc} />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default EcoWhatInBox;
